// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"styles_mainContent__1KK6l","narrow":"styles_narrow__14QMg","fullWidth":"styles_fullWidth__1Lmnm"};